import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { AppTokenService } from "./app-token.service";
import { HttpHandlerService } from "./http-handler.service";
@Injectable({providedIn:'root'})

export class ZoneService {
    _httpHandler: HttpHandlerService;
    _apiUrl = environment.apiUrl;
    _getResourceEndPoint = 'zones';

    constructor(private httpHandler: HttpHandlerService, private appTokenService: AppTokenService) {
        this._httpHandler = httpHandler;
    }

    public GetAll(params?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}?isactive=${params?.isactive}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetAllList(params?: any): Observable<any> {
        let full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/list?pagelimit=${params?.length}&pageoffset=${params?.start}`
        if (params?.refresh) {
            full_api_url = full_api_url + `&refresh=${new Date().getTime()}`;
        }
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetVendor(vendorcode: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${vendorcode}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public Add(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }
    public AddPeriod(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/period`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public Update(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public DeletePeriodById(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/period/${id}`;
        const request_options = this._httpHandler.prepareRequest(
            'DELETE',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }
    public Delete(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/${id}`;
        const request_options = this._httpHandler.prepareRequest(
            'DELETE',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public UploadZone(requestObj: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/upload`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            requestObj
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public GetAllPeriod(params?: any): Observable<any> {
        let full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/period`
        if (params?.refresh) {
            full_api_url = full_api_url + `?refresh=${new Date().getTime()}`;
        }
        
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetPeriodDetailbyId(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/periods/${id}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse);
    }

    public GetZoneDetailListById(userId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/period/${userId}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }
    
    public GetZonePeriodDetailById(userId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/info/${userId}`;
        const request_options = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public DeleteZoneDetailById(userId: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/detail/${userId}`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public UpdateZoneDetail(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/periods`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public UpdateZonePeriodDetail(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/info`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }

    public CheckZonePeriod(data: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/period/check`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            data
        );
        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse);
    }
}